<div id="lable-view-div" style="margin-left: 0px">
  <div class="data-view-top">
    <div
      class="chose-layers-div"
      id="multi_labels"
      style="display: block"
      *ngIf="showParcel && verify2"
    >
      <p id="labeldataset" style="margin-bottom: 6px">
        <span class="multi-layer-steps">{{ step1 }}</span
        ><b>Choose layers for which to download Labels:</b>
      </p>
      <ng-container *ngFor="let name of parcelLayer">
      <span style="display: inline"
        ><div class="labels_layers">
          <input
            type="checkbox"
            #layerData
            id="layerData"
            (change)="layerDataType($event)"
            class="label_view_checks"
            name="label_view_checks"
            value="Checked_layers"
            [value]="name"
            style="
              position: absolute;
              left: 60px;
              margin-right: 5px;
              margin-top: 2px;
            "
          />
          <p class="labels_layer_names" id="label_layers_names">{{name}}</p>
        </div></span
      >
    </ng-container>
    </div>
    <div class="chose-settings-div">
      <p id="lable-settings" style="display: block">
        <span class="single-layer-steps">{{ step2 }}</span
        ><span class="multi-layer-steps" style="display: none">{{ step2 }}</span
        ><b>Choose Settings:</b>
      </p>
      <span style="display: inline-block; margin-left: 45px; margin-top: 0px"
        ><input
          [(ngModel)]="radioButton"
          type="radio"
          name="Address"
          id="mail-view"
          [checked]="true"
          [value]="1" /></span
      >Use Mailing Address <br /><span
        style="display: inline-block; margin-left: 45px"
        ><input
          [(ngModel)]="radioButton"
          type="radio"
          name="Address"
          id="suits-view"
          [value]="2" /></span
      >Use Situs Address <br /><span
        style="display: inline-block; margin-left: 45px"
        ><input
          [(ngModel)]="radioButton"
          type="radio"
          name="Address"
          id="both-view"
          [value]="3" /></span
      >If different, create a label for each
      <small id="tooltip-both" class="mytooltip"
        ><span class="tooltiptext tip-bottom" style="margin-left: -13px"
          >If using both addresses, owner name will be replaced with "Current
          Occupant" for the situs address, where situs and mailing addresses do
          not match.</span
        >i</small
      >
      <br /><span
        style="
          display: inline-block;
          margin-left: 49px;
          margin-right: -4px !important;
        "
        ><input
          type="checkbox"
          id="check-duplicate"
          value="duplicates"
          [(ngModel)]="skipDuplicates"
      /></span>
      Skip duplicates
      <small id="tooltip-same" class="mytooltip"
        ><span class="tooltiptext tip-bottom" style="margin-left: -13px"
          >Where owner name and mailing address are the same for multiple
          parcels.</span
        >i</small
      ><br /><span
        style="
          display: inline-block;
          margin-left: 49px;
          margin-right: -4px !important;
        "
        ><input
          type="checkbox"
          id="check-APN"
          value="APNS"
          [(ngModel)]="showApns"
      /></span>
      Show APN on the label
      <small id="tooltip-duplicates" class="mytooltip"
        ><span class="tooltiptext tip-bottom" style="margin-left: -13px"
          >If duplicates are skipped, an APN will not display.</span
        >i</small
      ><br />
    </div>
  </div>
  <span
    style="
      display: inline-block;
      margin-left: 13px;
      margin-left: 21.5px !important;
    "
    ><span class="single-layer-steps">{{ step3 }}</span
    ><span class="multi-layer-steps" style="display: none">{{ step3 }}</span
    >
    <a (click)="download()" id="submit-pdf" download>Download</a>
    <a id="submit-pdf1" hidden download>Download</a>
    <span
      *ngIf="showMsg === true"
      class="err-select-layers glyphicon glyphicon-warning-sign"
      style="margin-left: 5px; font-style: normal"
    ></span
    ><span class="err-select-layers" *ngIf="showMsg === true">
      To download, select one or more layers above</span
    ></span
  >
  <hr id="separater-line" />
  <div class="data-view-desc">
    <p>Labels are output in Avery 5160 format.</p>
    <p>
      If you have selected multiple layers to download, each will generate a
      separate PDF file and will be downloaded automatically, appearing in your
      downloads folder.
    </p>
  </div>
</div>
<app-loader></app-loader>
